import React from "react";

import { useTranslation } from "utils";

import { Button, Col, Form, Link, Row } from "components";

interface PasswordButtonsProps {
  loading: boolean;
}

export const PasswordButtons = ({ loading }: PasswordButtonsProps) => {
  const { t } = useTranslation("signinup");

  return (
    <>
      <Row>
        <Col className="left">
          <Link to="/sign-in" className="link green-text">
            {t("changePassword.buttons.signin")}
          </Link>
        </Col>
      </Row>
      <Row className="margin-top-325">
        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
              {t("changePassword.buttons.sendEmail")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
